import { courses } from "./courses"
import { students } from "./students"

export const tracking = {
  courses,
  students,
}
